import { tickRoster } from '@/game/view/tickCache';
import { useSimFrame } from '../app/simFrame';

/**
 * "Idle 2 .": jumps to the next idle or no-work-found worker (selects it and
 * goes there), like the `.` key. Hidden when nobody is idle.
 */
export function IdleWorkersButton({ onCycle }: { onCycle: () => void }) {
  const { view, playerId, rules, terrain } = useSimFrame();
  const idle = tickRoster(view, { terrain, rules, playerId }).idle.length;
  if (idle === 0) return null;
  return (
    <button
      type="button"
      onClick={onCycle}
      title="Select the next idle worker and go there (key .)"
      className="pill pointer-events-auto flex h-7 shrink-0 cursor-pointer items-center gap-1.5 self-start px-3 text-xs transition hover:bg-fill-hover"
    >
      <span>Idle</span>
      <span className="tabular-nums text-warn">{idle}</span>
      <kbd className="text-fg-subtle">.</kbd>
    </button>
  );
}
